/**
 * DJI México - 系列页埋点（page_type=collection）
 * ==================================================================
 * 严格按《数据埋点定义文档》Collection 实施清单表（C1–C7）实施。
 *
 *   C1  首屏商品列表曝光      view_item_list                             P0 L1/L2
 *   C2  左侧筛选器            filter_apply                               P0 L3
 *   C3  排序器                sort_change                                P0 L3
 *   C4  筛选/排序后批次曝光   view_item_list                             P0 L1/L2
 *   C5  商品卡进 PDP          select_item                                P0 L1
 *   C6  商品卡快速加购        add_to_cart                                P0 条件必做 L1
 *   C7  分页/加载更多/子类目  item_list_load_more / category_entry_click  P1
 *
 * ------------------------------------------------------------------
 * 线上实测结论（2026-08-25，/collections/camera-drones）
 * ------------------------------------------------------------------
 * 商品网格由 Globo Filter 应用运行时注入，主题只提供空容器：
 *   #gf-products / [data-globo-filter-items] / .collection-products-list 三者同时存在，
 *   逗号选择器命中哪个不可控，必须按优先级依次取。
 *   卡片 .spf-product-card × 12、product-form[data-product-id] × 12、
 *   button.product-card-atc × 12 —— 这几个原判定正确。
 *
 * 但筛选与排序的选择器上一版全错：
 *   [data-filter-value] → 0、.gf-option → 0、select[name=sort_by] → 0
 * 真实结构：
 *   筛选 <div class="gf-option-block gf-option-878599" data-filter-type="Collection"
 *          data-filter-id="878599">
 *          <div class="gf-block-title">SERIE DE PRODUCTOS</div>
 *          <div class="gf-option-box"><a onclick="toggleRadioFilter(878599,'355538796741')">…</a>
 *   排序 <div class="sort-by"><button id="sortButton" class="sort-by-toggle">当前排序</button>
 *          <ul class="globo-dropdown-custom__options"><li data-sort="price-descending">…
 *
 * DOM 依据见 选择器契约-线上实测.md
 */
(function (w, d) {
  'use strict';

  var DL = w.DJIDataLayer;
  if (!DL) return;
  if ((DL.ctx.page_type || '') !== 'collection') return;
  if (w.__djiCollectionTracking) return;
  w.__djiCollectionTracking = 1;

  var CTX = DL.ctx.collection || {};

  /* ================================================================ */
  /* 表格指定的 component_id / placement                               */
  /* ================================================================ */

  var CFG = {
    grid:   { component_id: 'collection_product_grid', placement: 'collection_grid' },
    filter: { component_id: 'collection_filter',       placement: 'collection_sidebar' },
    sort:   { component_id: 'collection_sort',         placement: 'collection_top_right' },
    page:   { component_id: 'collection_pagination',   placement: 'collection_grid' },
    subcat: { component_id: 'collection_subcategory',  placement: 'collection_grid' }
  };

  /* 线上实测的 DOM 钩子 */
  var SEL = {
    /* ⚠️ 三个容器同时存在，按优先级依次取，不能写成逗号选择器 */
    gridCandidates: ['#gf-products', '[data-globo-filter-items]', '.collection-products-list'],
    card:        '.spf-product-card',
    productForm: 'product-form[data-product-id]',
    variantInput:'form[action*="/cart/add"] input[name="id"]',
    atc:         'button.product-card-atc, button[name="add"]',

    filterBlock: '.gf-option-block[data-filter-id]',
    filterTitle: '.gf-block-title',
    filterLink:  '.gf-option-box a, .gf-option-block a',
    filterInput: '.gf-option-block input[type="checkbox"], .gf-option-block input[type="radio"]',
    /* ⚠️ .gf-actions 里通常同时有「Aplicar」和「Borrar todo」，
       不按文案收窄会把「应用筛选」记成 action:'clear'，同一次筛选双发且方向相反。 */
    filterClear: '.gf-actions a, .gf-actions button, .gf-filter-selection a',
    filterClearText: /borrar|limpiar|clear|quitar|reset|elimina/i,

    sortHost:    '.sort-by',
    sortToggle:  '#sortButton, .sort-by-toggle',
    /* ⚠️ 属性名是 data-sort，不是 data-value ——
       线上实测整页 [data-value] 命中数为 0，sort_change 因此永不触发。
       data-sort 的取值是 Shopify 标准排序 key（best-selling / price-ascending …），
       与 URL 的 sort_by 参数、Liquid 给的 collection.current_sort 同一口径。
       两种属性都保留：Globo 换写法时不至于再次归零。 */
    sortOption:  '.globo-dropdown-custom__options li[data-sort], .globo-dropdown-custom__options li[data-value], .sort-by li[data-sort], .sort-by li[data-value]',

    pager:       '.pagination a, [class*="load-more"], button[class*="more"]',
    /* 子类目：本页实测无承载元素，保留委托，后台配上即自动生效 */
    subcat:      '[data-subcategory] a, .gf-subcategory a, [class*="subcategory"] a',

    totalCount:  '[total-product-count], .gf-summary, [class*="results-count"]'
  };

  /* ================================================================ */
  /* 工具                                                              */
  /* ================================================================ */

  function all(root, sel) { return root ? [].slice.call(root.querySelectorAll(sel)) : []; }
  function txt(el) { return el && el.innerText ? el.innerText.trim().replace(/\s+/g, ' ').slice(0, 80) : ''; }
  function visible(el) {
    if (!el) return false;
    var r, s;
    try { r = el.getBoundingClientRect(); s = w.getComputedStyle(el); } catch (e) { return false; }
    return s.display !== 'none' && s.visibility !== 'hidden' && r.height > 0;
  }

  /**
   * ⚠️ 三个候选容器同时存在，且都可能是「有非零高度但没有卡片」的空壳。
   * 只判「存在 + 可见」会一直返回空壳，导致 cards() 恒为 0：
   * C1/C4 全无、resultsCount 走静态回退、select_item 的 index 恒为 0。
   * 所以挑「实际装着最多商品卡」的那个；都没有卡片时再按优先级兜底。
   */
  function gridEl() {
    var best = null, bestN = 0, fallback = null;
    for (var i = 0; i < SEL.gridCandidates.length; i++) {
      var el = d.querySelector(SEL.gridCandidates[i]);
      if (!el || !visible(el)) continue;
      if (!fallback) fallback = el;
      var n = el.querySelectorAll(SEL.card).length;
      if (n > bestN) { bestN = n; best = el; }
    }
    return best || fallback;
  }

  function cards() { return all(gridEl() || d, SEL.card).filter(visible); }

  function productIdOf(card) {
    var pf = card.querySelector(SEL.productForm);
    if (pf) return String(pf.getAttribute('data-product-id') || '');
    var any = card.querySelector('[data-product-id]');
    return any ? String(any.getAttribute('data-product-id') || '') : '';
  }

  function variantIdOf(card) {
    var i = card.querySelector(SEL.variantInput);
    return i && i.value ? String(i.value) : '';
  }

  function hrefOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    return a ? a.getAttribute('href') : '';
  }

  /**
   * active_filters。
   * ⚠️ 实测 Globo 的 URL 参数格式是 filter.<数字ID>=<Label>（如 filter.878887=Accesorios），
   * 不是 Shopify 原生的 filter.p.m.*，所以 Liquid 侧 collection.filters[].active_values 恒空、
   * active_filters_raw 回退路径事实上是死的 —— 只能从 URL 解析。
   *
   * 数字 filter id 对分析没有意义，用页面上的 data-filter-type / .gf-block-title
   * 把它映射成可读的筛选组名。
   * 输出统一排序，避免用户勾选先后不同产生两个不同取值。
   */
  function filterIdMap() {
    var map = {};
    all(d, SEL.filterBlock).forEach(function (b) {
      var id = b.getAttribute('data-filter-id');
      if (!id) return;
      map[id] = b.getAttribute('data-filter-type') || txt(b.querySelector(SEL.filterTitle)) || id;
    });
    return map;
  }

  function activeFilters() {
    var out = [];
    var map = filterIdMap();
    try {
      var q = new w.URLSearchParams(w.location.search);
      q.forEach(function (v, k) {
        if (!/^filter\./i.test(k)) return;
        var id = k.replace(/^filter\./i, '');
        out.push((map[id] || id) + '=' + v);
      });
    } catch (e) {}
    out.sort();                       /* 勾选顺序不同不应产生不同取值 */
    return out;
  }

  /** 排序项的取值：Globo 用 data-sort，旧写法用 data-value */
  function sortValueOf(li) {
    if (!li) return '';
    return li.getAttribute('data-sort') || li.getAttribute('data-value') || '';
  }

  function currentSort() {
    try {
      var q = new w.URLSearchParams(w.location.search);
      var s = q.get('sort_by');
      if (s) return s;
    } catch (e) {}
    /* URL 没带时读排序按钮当前文案对应的 value */
    var btn = d.querySelector(SEL.sortToggle);
    if (btn) {
      var label = txt(btn);
      var hit = all(d, SEL.sortOption).filter(function (li) { return txt(li) === label; })[0];
      if (hit) return sortValueOf(hit);
    }
    return CTX.current_sort || '';
  }

  function resultsCount() {
    /* ⚠️ 主题的 [total-product-count] 是 Liquid 渲染的集合总数，
       Globo 筛选时纹丝不动（templates/collection.json 里 enable_filtering=false，
       主题的 facets.js 永远不会更新它）。所以以「实际渲染出的卡片数」为准。 */
    var n = cards().length;
    if (n) return n;
    var el = d.querySelector(SEL.totalCount);
    if (el) {
      var m = txt(el).match(/\d+/);
      if (m) return Number(m[0]);
    }
    return 0;
  }

  function base(cfg, extra) {
    var af = activeFilters();
    var out = {
      page_type: 'collection',
      component_id: cfg.component_id,
      placement: cfg.placement,
      collection_id: CTX.id != null ? String(CTX.id) : undefined,
      collection_handle: CTX.handle,
      active_filters: af.join('|'),          /* 无筛选时是空串，不是缺字段 */
      active_filter_count: af.length,
      current_sort: currentSort()
    };
    for (var k in (extra || {})) out[k] = extra[k];
    return out;
  }

  /** 商品卡点击的 element_id（表格枚举 product_image|product_title|product_card） */
  function cardElementId(t) {
    if (t.closest('img, picture, [class*="image"], [class*="media"]')) return 'product_image';
    if (t.closest('[class*="title"], h2, h3, h4')) return 'product_title';
    return 'product_card';
  }

  /* 卡片上的商品名 / 价格 / 售罄标记 —— 线上实测的结构 */
  var CARD_TITLE = '[class*="product-title"], [class*="card__title"], h3, h2';
  var CARD_PRICE = '[class*="price"]';

  function cardTitle(card) {
    var t = txt(card.querySelector(CARD_TITLE));
    return t || '';
  }

  /** "Precio habitual $87,599 MXN" → 87599 */
  function cardPrice(card) {
    var raw = txt(card.querySelector(CARD_PRICE));
    if (!raw) return undefined;
    var m = raw.replace(/\s/g, '').match(/([\d.,]+)/g);
    if (!m || !m.length) return undefined;
    /* 取最后一个数字串：促销时前面是原价、后面是现价 */
    var num = m[m.length - 1].replace(/,/g, '');
    var v = parseFloat(num);
    return isNaN(v) ? undefined : v;
  }

  function cardAvailability(card) {
    if (card.classList && (card.classList.contains('spf-soldout') ||
        card.className.indexOf('soldout') > -1)) return 'out_of_stock';
    return 'in_stock';
  }

  /**
   * ⚠️ 系列页没有 window.__pageflyProducts（那是 PageFly 页面才注入的），
   * 所以 DL.item() 拿不到商品名与价格 —— 实测 items 里只剩 item_id / item_brand / quantity。
   * 表格 C1/C4/C5 都要求 items[] 有意义，这里从卡片 DOM 补齐。
   */
  function itemOf(card, index) {
    var pid = productIdOf(card);
    if (!pid) return null;
    return DL.item(pid, {
      index: index,
      item_list_id: 'collection_' + (CTX.handle || 'all'),
      item_list_name: CTX.title || CTX.handle || 'Collection',
      variant_id: variantIdOf(card) || undefined,
      item_name: cardTitle(card) || undefined,
      price: cardPrice(card),
      availability: cardAvailability(card)
    });
  }

  /* ================================================================ */
  /* C1 / C4 · 批次曝光                                                */
  /* ================================================================ */

  var batchIndex = 0;
  var pendingTrigger = null;      /* 由筛选/排序/加载更多设置，首屏为 initial */
  var stopObserve = null;

  function emitBatch(trigger) {
    var grid = gridEl();
    if (!grid) return;

    var list = cards();
    /* ⚠️ 关键：Globo 在 DOMContentLoaded 之后才注入卡片。
       上一版在卡片还是 0 个时就消费了去重键，导致 C1 首屏曝光永久丢失。
       这里先确认有卡片，再建 observer、再消费去重键。 */
    if (!list.length) return;

    batchIndex += 1;
    var thisBatch = batchIndex;
    gridSignature = currentSignature();   /* 与 watchRerender 共享，避免自己触发自己 */
    firstBatchDone = true;
    var af = activeFilters().join('|');
    var sort = currentSort();
    var key = 'view_item_list|collection_' + (CTX.handle || 'all') + '|' + af + '|' + sort + '|' + thisBatch;

    /* ⚠️ 上一版每次都新建 observer 且丢弃返回值，旧的从不 disconnect：
       连续改两次筛选再滚回列表，两个 observer 会同时命中 → 同一屏发两条。 */
    if (stopObserve) { stopObserve(); stopObserve = null; }

    stopObserve = DL.observe(grid, { ratio: 0.5, dwell: 1000 }, function (el, meta) {
      stopObserve = null;
      if (!DL.once(key)) return;
      var now = cards();
      var items = now.map(function (c, i) { return itemOf(c, i + 1); }).filter(Boolean);
      if (!items.length) return;
      DL.push('view_item_list', base(CFG.grid, {
        item_list_id: 'collection_' + (CTX.handle || 'all'),
        item_list_name: CTX.title || CTX.handle || 'Collection',
        list_batch_index: thisBatch,
        trigger_source: trigger,            /* initial / filter / sort / load_more */
        exposure_rule: meta.rule,
        exposure_ratio: meta.ratio_observed,
        items: items
      }));
    });
  }

  /** 等 Globo 真的把卡片渲染出来再发首屏批次 */
  function waitFirstBatch() {
    var tries = 0;
    (function poll() {
      if (cards().length) { emitBatch('initial'); return; }
      if (++tries < 40) w.setTimeout(poll, 250);   /* 最多等 10s */
      else DL.log('collection: 10s 内未渲染出商品卡，C1 未发送');
    })();
  }

  /**
   * 监听网格重渲染。
   * ⚠️ 上一版把 MutationObserver 绑在启动那一刻的容器上，
   * Globo 换容器（主题的 .collection-products-list → #gf-products）后
   * observer 指向游离节点，后续所有 C4 批次一并失效。
   * 这里观察 document.body 的子树，并每次重新取容器。
   */
  var gridSignature = '';
  var firstBatchDone = false;

  function currentSignature() {
    return cards().map(function (c) { return productIdOf(c); }).join(',');
  }

  function watchRerender() {
    var settle = null;

    function check() {
      var now = currentSignature();
      if (now === gridSignature) return;
      gridSignature = now;
      if (!now) return;                       /* 清空阶段不算一批 */

      /* ⚠️ 首批次还没发出去时，这次「空 → 有」正是 Globo 的首次注入，
         不是重渲染。上一版把它当成 load_more 批次，会调 stopObserve()
         把首批次那个还没触发的 observer 直接掐掉 ——
         结果每个系列页只发一条 view_item_list，
         且 list_batch_index 恒为 2、trigger_source 恒为 load_more。 */
      if (!firstBatchDone) return;

      var trigger = pendingTrigger || 'load_more';
      pendingTrigger = null;
      emitBatch(trigger);
    }

    try {
      new MutationObserver(function () {
        if (settle) w.clearTimeout(settle);
        settle = w.setTimeout(check, 400);
      }).observe(d.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  /* ================================================================ */
  /* C2 · 筛选器                                                       */
  /* ================================================================ */

  /* 表格枚举：filter_group=product_series|product_type。
     Globo 侧给的是 data-filter-type="Collection" / "Product type"
     与组标题 "SERIE DE PRODUCTOS" / "TIPO DE PRODUCTO"，需要映射过去。 */
  var FILTER_GROUPS = [
    [/serie|series|collection/i,      'product_series'],
    [/tipo|type|categor/i,            'product_type']
  ];

  function filterGroupOf(el) {
    var block = el.closest(SEL.filterBlock);
    if (!block) return { id: '', name: '' };
    var raw = block.getAttribute('data-filter-type') || txt(block.querySelector(SEL.filterTitle)) || '';
    var mapped = '';
    for (var i = 0; i < FILTER_GROUPS.length; i++) {
      if (FILTER_GROUPS[i][0].test(raw)) { mapped = FILTER_GROUPS[i][1]; break; }
    }
    return {
      id: block.getAttribute('data-filter-id') || '',
      name: mapped || raw,       /* 映射不中时保留原值，便于发现新增筛选组 */
      raw: raw
    };
  }

  /** 从 onclick="toggleRadioFilter(878599,'355538796741')" 里取值 */
  function filterValueOf(a) {
    var oc = a.getAttribute('onclick') || '';
    var m = oc.match(/\(\s*[\d'"]+\s*,\s*['"]([^'"]+)['"]/);
    if (m) return m[1];
    return a.getAttribute('data-value') || txt(a);
  }

  function initFilter() {
    d.addEventListener('click', function (evt) {
      var t = evt.target;
      if (!t || !t.closest) return;

      /* 清除筛选 */
      var clear = t.closest(SEL.filterClear);
      if (clear && !SEL.filterClearText.test(txt(clear))) clear = null;   /* 不是清除按钮 */
      if (clear) {
        var g0 = filterGroupOf(clear);
        pendingTrigger = 'filter';
        recordFilter('clear', g0, '', txt(clear));
        return;
      }

      var link = t.closest(SEL.filterLink);
      var input = t.closest(SEL.filterInput);
      if (!link && !input) return;

      var el = link || input;
      var g = filterGroupOf(el);
      if (!g.id) return;

      /**
       * action 判定必须分形态：
       *  - <a>：没有 pre-click activation，click 时读到的 checked 类是【旧】状态 → 取反
       *  - <input>：按 HTML 规范，click 派发前 checked 已更新 → 读到的是【新】状态 → 不取反
       * 上一版对两者都取反，会把「勾选」记成 remove。
       */
      var willBeOn;
      if (input) willBeOn = !!input.checked;
      else willBeOn = !(el.classList && el.classList.contains('checked'));

      pendingTrigger = 'filter';
      recordFilter(willBeOn ? 'apply' : 'remove', g,
                   link ? filterValueOf(link) : (input.value || ''),
                   txt(el));
    }, true);
  }

  /**
   * 必须等列表实际刷新后才发，previous 在点击瞬间取、results 在刷新后取。
   *
   * ⚠️ 轮询只能用 cards().length，不能用 resultsCount()：
   * 后者在卡片数为 0 时会回退到 [total-product-count]（Liquid 渲染的集合静态总数）。
   * Globo 刷新时会先清空网格，那一瞬间 cards()=0 → 回退值突然变成集合总数 →
   * 轮询误判为「刷新完成」，推出 results_count = 集合总数而不是筛选结果数。
   */
  function recordFilter(action, group, valueId, valueName) {
    var prev = cards().length;
    var tries = 0;
    (function poll() {
      var now = cards().length;
      if ((now !== prev && now > 0) || tries > 20) {
        DL.push('filter_apply', base(CFG.filter, {
          action: action,
          filter_group: group.name || group.id || undefined,
          filter_value_id: valueId || undefined,
          filter_value_name: valueName || undefined,
          previous_results_count: prev,
          results_count: now
        }));
        return;
      }
      tries += 1;
      w.setTimeout(poll, 250);        /* 最多等 5s */
    })();
  }

  /* ================================================================ */
  /* C3 · 排序器                                                       */
  /* ================================================================ */

  function initSort() {
    /* ⚠️ 排序不是 <select>，监听 change 永远不触发。
       实测是 button.sort-by-toggle + ul.globo-dropdown-custom__options > li[data-sort]。
       属性名一度写成 data-value，整页 0 命中，sort_change 一条都发不出来。 */
    d.addEventListener('click', function (evt) {
      var t = evt.target;
      if (!t || !t.closest) return;
      var li = t.closest(SEL.sortOption);
      if (!li) return;

      var from = currentSort();
      var to = sortValueOf(li);
      if (!to || to === from) return;

      pendingTrigger = 'sort';

      /* 必须等列表实际重渲染。上一版第一轮 cnt 就非 0 → 立即推送，
         results_count 取的是排序前的旧值，直接违反 C3 的口径。 */
      var beforeSig = cards().map(productIdOf).join(',');
      var tries = 0;
      (function poll() {
        var nowSig = cards().map(productIdOf).join(',');
        if ((nowSig && nowSig !== beforeSig) || tries > 20) {
          DL.push('sort_change', base(CFG.sort, {
            sort_from: from,
            sort_to: to,
            results_count: resultsCount()
          }));
          return;
        }
        tries += 1;
        w.setTimeout(poll, 250);
      })();
    }, true);
  }

  /* ================================================================ */
  /* C5 · 商品卡进 PDP  /  C6 · 快速加购                                */
  /* ================================================================ */

  var lastAdd = null;

  function initCardClicks() {
    d.addEventListener('click', function (evt) {
      var t = evt.target;
      if (!t || !t.closest) return;
      var card = t.closest(SEL.card);
      if (!card) return;

      var list = cards();
      var index = list.indexOf(card) + 1;

      /* C6：只记意图，等 /cart/add 成功再上报 */
      if (t.closest(SEL.atc)) {
        var btn = t.closest(SEL.atc);
        if (!DL.isInteractive(btn)) return;
        lastAdd = {
          at: Date.now(),
          index: index,
          productId: productIdOf(card),
          variantId: variantIdOf(card),
          /* 表格枚举：add_method=quick_add|product_form */
          method: card.querySelector(SEL.productForm) ? 'product_form' : 'quick_add',
          impl: card.querySelector(SEL.productForm) ? 'theme_product_form' : 'app'
        };
        return;
      }

      /* C5 */
      var href = hrefOf(card);
      if (!href) return;
      var link = t.closest('a[href*="/products/"]') || card.querySelector('a[href*="/products/"]');
      DL.afterTick(function () {
        var __np = DL.navPush(evt, link || card);
        if (!__np) return;
        var item = itemOf(card, index);
        if (!item) return;
        __np('select_item', base(CFG.grid, {
          item_list_id: 'collection_' + (CTX.handle || 'all'),
          item_list_name: CTX.title || CTX.handle || 'Collection',
          /* 表格枚举：product_image|product_title|product_card */
          element_id: cardElementId(t),
          index: index,
          destination_url: href,
          items: [item]
        }));
      });
    }, true);
  }

  function initAddToCart() {
    DL.onCartSuccess(function (kind, body) {
      if (kind !== 'add') return;
      var ctx = lastAdd && Date.now() - lastAdd.at < 10000 ? lastAdd : null;
      if (!ctx) return;
      lastAdd = null;

      var lines = [];
      if (body && body.items && body.items.length) lines = body.items;
      else if (body && body.id) lines = [body];

      DL.fetchCart().then(function (cart) {
        if (!cart) return;
        var items = DL.itemsFromCartLines(lines, {
          item_list_id: 'collection_' + (CTX.handle || 'all'),
          item_list_name: CTX.title || CTX.handle || 'Collection',
          index: ctx.index
        });
        if (!items.length) return;
        DL.push('add_to_cart', base(CFG.grid, {
          item_list_id: 'collection_' + (CTX.handle || 'all'),
          item_list_name: CTX.title || CTX.handle || 'Collection',
          element_id: 'quick_add',
          add_method: ctx.method,
          button_implementation: ctx.impl,
          index: ctx.index,
          cart_total_items: cart.item_count,
          value: DL.itemsValue(items),
          items: items
        }));
      });
    });
  }

  /* ================================================================ */
  /* C7 · 分页 / 加载更多 / 子类目                                      */
  /* ================================================================ */

  function initPagination() {
    d.addEventListener('click', function (evt) {
      var t = evt.target;
      if (!t || !t.closest) return;

      var sub = t.closest(SEL.subcat);
      if (sub) {
        var href = sub.getAttribute('href') || '';
        DL.afterTick(function () {
          var __np = DL.navPush(evt, sub);
          if (!__np) return;
          var m = href.match(/\/collections\/([^/?#]+)/);
          __np('category_entry_click', base(CFG.subcat, {
            category_id: m ? m[1] : undefined,
            category_level: 2,
            destination_url: href || undefined
          }));
        });
        return;
      }

      var pager = t.closest(SEL.pager);
      if (!pager) return;
      var isPage = pager.matches('.pagination a');
      var before = cards().length;
      pendingTrigger = 'load_more';

      /* 等新商品真的渲染出来。上一版用 900ms 硬等待，慢网络下 loaded_item_count 恒为 0。 */
      var tries = 0;
      (function poll() {
        var now = cards().length;
        if (now !== before || tries > 24) {
          DL.push('item_list_load_more', base(CFG.page, {
            action: isPage ? 'page_change' : 'load_more',
            page_number: pageNumber(),
            loaded_item_count: isPage ? now : Math.max(0, now - before),
            item_list_id: 'collection_' + (CTX.handle || 'all')
          }));
          return;
        }
        tries += 1;
        w.setTimeout(poll, 250);      /* 最多等 6s */
      })();
    }, true);
  }

  function pageNumber() {
    try {
      var q = new w.URLSearchParams(w.location.search);
      return Number(q.get('page') || 1);
    } catch (e) { return 1; }
  }

  /* ================================================================ */
  /* 启动                                                              */
  /* ================================================================ */

  function start() {
    if (start.__done) return;
    start.__done = 1;
    initFilter();
    initSort();
    initCardClicks();
    initAddToCart();
    initPagination();
    waitFirstBatch();
    watchRerender();
    DL.log('collection tracking ready', {
      grid: gridEl() ? gridEl().id || gridEl().className : null,
      cards: cards().length
    });
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start);
  else start();
})(window, document);
